/*
	Formularz laureata (templates/index/winner.html.twig).

	Po wysłaniu makieta nie przenosi nigdzie użytkownika — karta formularza znika,
	a na jej miejscu staje karta „Dziękujemy za wypełnienie formularza laureata!”
	(artboardy XD „Podziękowanie za wypełnienie formularza laureata I/II Stopnia”).
	Po odświeżeniu strony w tym samym miejscu wyjdzie już komunikat „Formularz laureata
	został już uzupełniony” — o tym decyduje App\Controller\IndexController::winner.

	Lista zarejestrowanych danych ma inną kolejność i inne etykiety niż wspólna
	`registered-data.js` (w makiecie rodzaj i numer dokumentu stoją w JEDNYM wierszu),
	więc składamy ją tutaj. Kolejność wprost z artboardu.
*/
const POLA = [
    ['firstname', 'imię'],
    ['lastname', 'nazwisko'],
    ['email', 'adres e-mail'],
    ['iban', 'nr rachunku bankowego'],
    ['document', 'Rodzaj i numer dokumentu tożsamości'],
    ['pesel', 'numer PESEL'],
    ['street', 'adres zamieszkania'],
    ['birthDay', 'data urodzenia'],
    ['citizenship', 'obywatelstwo'],
    ['phone', 'numer telefonu'],
];

// etykiety `personalData.idDocumentType` — te same, co w liście wyboru
// (bundles/Contest/Resources/config/form_defaults.yaml)
const DOKUMENTY = {
    passport: 'paszport',
    id_card: 'dowód osobisty',
};

const adres = (data) => [
    [data.street, data.streetNr].filter(Boolean).join(' ') + (data.flatNr ? `/${data.flatNr}` : ''),
    [data.zipCode, data.city].filter(Boolean).join(' '),
].filter(Boolean).join(', ');

const setLaureatData = (data, container) => {
    const wartosci = {
        ...data,
        document: [DOKUMENTY[data.identityDocumentType] || data.identityDocumentType, data.identityDocumentNr]
            .filter(Boolean).join(' '),
        street: data.street ? adres(data) : null,
    };

    container.querySelectorAll('ul.registered-data-list').forEach(list => {
        list.innerHTML = POLA
            .filter(([key]) => wartosci[key])
            .map(([key, label]) => {
                // numer rachunku łamał się w połowie (26 znaków + etykieta nie mieszczą się
                // w 385 px ramki) — w `<span>` z `nowrap` łamie się najwyżej PRZED numerem
                const wartosc = key === 'iban'
                    ? `<span class="registered-data-nowrap">${escapeHTML(wartosci[key])}</span>`
                    : escapeHTML(wartosci[key]);

                return `<li><strong>${label}</strong>: ${wartosc}</li>`;
            })
            .join('');
    });

    // „Drukuj” prowadzi do PDF-a z trasy `api_data_uuid`
    container.querySelectorAll('a.registered-data-pdf-print').forEach(link => {
        link.setAttribute('href', data.pdf || '#');
    });
};

$('.laureat-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    const komunikat = document.querySelector('[data-laureat-dziekujemy]');
    if (!komunikat) return;

    setLaureatData(data, komunikat);

    document.querySelector('[data-laureat-karta]')?.remove();
    // strona skraca się do wysokości komunikatu, więc dolna dłoń (y 834 na kanwie)
    // wisiałaby pod treścią i rozciągała dokument — patrz sections/s-laureat.scss
    komunikat.closest('.s-laureat')?.classList.add('s-laureat--po-wyslaniu');
    komunikat.hidden = false;
    komunikat.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

$('.laureat-form').on('submit-error', function(event, xhr) {
    event.preventDefault();
    if (xhr.status == 410) {
        // termin z regulaminu minął między wczytaniem strony a wysłaniem formularza —
        // po przeładowaniu wyjdzie ekran „Link nieaktywny”
        window.location.reload();
    }
});

/*
	„Nie posiadam numeru PESEL” przełącza, co jest wymagane: albo PESEL, albo adres
	zamieszkania, data urodzenia i obywatelstwo (regulamin § 5 ust. 9 pkt 1). Po stronie
	serwera pilnują tego `_enabled_if` w metadanych przejścia `UserPrize::TRANSITION_FILL`,
	tutaj chodzi o to, żeby pola nie blokowały walidacji HTML-owej.

	Te same pola są do tego momentu UKRYTE — klasa `--bez-pesel` na formularzu odsłania
	wiersze z `form-group--zalezne-pesel` (sections/s-laureat.scss). Widoczność i `disabled`
	idą razem, żeby ukryte pole nigdy nie blokowało wysyłki.
*/
$('[name="personal_data[noPesel]"]').on('change', function() {
    const bezPesel = $(this).prop('checked');

    this.form.classList.toggle('laureat-form--bez-pesel', bezPesel);

    $('[name="personal_data[pesel]"]', this.form.elements).prop('disabled', bezPesel);

    const zalezne = [
        '[name="personal_data[street]"]',
        '[name="personal_data[streetNr]"]',
        '[name="personal_data[flatNr]"]',
        '[name="personal_data[zipCode]"]',
        '[name="personal_data[city]"]',
        '[name="personal_data[citizenship]"]',
        '[name^="personal_data[birthDay]"]',
    ];
    $(zalezne.join(', '), this.form.elements).prop('disabled', !bezPesel);
}).trigger('change');
